import React from 'react';
import { connect } from 'react-redux';
import Grid from '@mui/material/Grid2';
import {
  SmartAgentLabel,
  SmartAgentText,
  SmartProfileImage,
  SmartAgentContainer,
} from '~/FielderElements/SmartTaskTable/SmartStyles';
import RoleUtils from 'FielderUtils/roles/roleUtils';
/** Helper Components */
const LabelText = ({ label, text }) => (
  <Grid container size={12} sx={{ my: 1.5 }}>
    <Grid size={12}>
      <SmartAgentLabel>{label}</SmartAgentLabel>
    </Grid>
    <Grid size={12}>
      <SmartAgentText>{text}</SmartAgentText>
    </Grid>
  </Grid>
);
/** Phone/Distance format */
const formatPhone = (phone = '') => {
  const clean = phone.replace(/\D/g, '');
  if (clean.length < 9) return phone;
  return `+${clean.slice(0, 2)} (${clean.slice(2, 5)}) ${clean.slice(5, 8)}-${clean.slice(8)}`;
};
const formatDistance = (meters = '') => {
  const km = Number(meters) / 1000;
  return isNaN(km) ? '' : `${km.toFixed(1)} km`;
};
function TaskAgent({ taskAgent, lan, user }) {
  if (!taskAgent) return null;
  const isClient = RoleUtils.isUserClient(user);
  return (
    <SmartAgentContainer>
      <Grid container spacing={2} sx={{ width: '100%' }}>
        {/* Profile picture */}
        <Grid
          size={{ xs: 12, md: 3 }}
          sx={{ display: 'flex', justifyContent: { xs: 'center', md: 'flex-start' } }}
        >
          <SmartProfileImage component="img" src={taskAgent.profilePicture} alt={lan.assignedAgent} />
        </Grid>
        {/* Agent identity */}
        <Grid size={{ xs: 12, md: 4 }}>
          <LabelText label={lan.assignedAgent} text={taskAgent.name} />
          {!isClient && (
            <>
              <LabelText label={lan.assignedWork} text={taskAgent.workSchedule} />
              <LabelText label={lan.phoneAgent} text={formatPhone(taskAgent.phone)} />
              <LabelText label={lan.emailAgent} text={taskAgent.email} />
            </>
          )}
        </Grid>
        {/* Vehicle / Distance */}
        <Grid size={{ xs: 12, md: 5 }}>
          <LabelText label={lan.typeVehicle} text={taskAgent.vehicleType} />
          <LabelText label={lan.idVehicle} text={taskAgent.vehicleId} />
          {!isClient && (
            <>
              <LabelText label={lan.timeTraveled} text={taskAgent.timeTaken} />
              <LabelText
                label={`${lan.distanceTraveled} (kms)`}
                text={formatDistance(taskAgent.distanceTraveled)}
              />
            </>
          )}
        </Grid>
      </Grid>
    </SmartAgentContainer>
  );
}
const mapStateToProps = (state) => ({
  user: state.utils.session.user,
});
export default connect(mapStateToProps)(TaskAgent);
//Original code:
/*import React, { Component } from 'react';
import RoleUtils from 'FielderUtils/roles/roleUtils';
import Grid from '@mui/material/Grid2';
import './TaskDetails.css';
import { connect } from 'react-redux';
class TaskAgent extends Component {
	formatPhone = (phone) => {
		var countryCode = '+' + phone.slice(0, 2) + ' ';
		var part1 = '(' + phone.slice(2, 5) + ') ';
		var part2 = phone.slice(5, 8) + '-' + phone.slice(8);
		return [countryCode, part1, part2].join('');
	};
	formatDistance = (meters) => {
		if (meters !== '') {
			var km = parseInt(meters) / 1000;
			return km.toFixed(1) + ' km';
		}
		return '';
	};
  LabelText = (props) => {
    var text = props.text;
    return (
      <Grid container className={props.className} size={12}>
        <Grid size={12} className={'td-label-input ' + props.labelClass}>
          {props.label}
        </Grid>
        <Grid size={12} className={'td-default-text align-left ' + props.textClass}>
          {text}
        </Grid>
      </Grid>
    );
  };
  render() {
    return (
      <div className='container' style={{ height: '350px%' }}>
        <React.Fragment>
          <Grid container spacing={2}>
            <Grid size={{ xs: 12, md: 3 }} className='my-auto '>
              <img
                src={this.props.taskAgent.profilePicture}
                className=' pofile-pic '
                alt='Imagen de Perfil'
              />
            </Grid>

            {RoleUtils.isUserClient(this.props.user) ? (
              <Grid size={{ xs: 12, md: 4 }}>
                <Grid>
                  <this.LabelText
                    label={this.props.lan.assignedAgent}
                    text={this.props.taskAgent.name}
                    className='my-3'
                    textClass='td-task-number taskAgent-color'
                  />
                </Grid>
              </Grid>
            ) : (
              <Grid size={{ xs: 12, md: 4 }} className='my-auto'>
                <Grid>
                  <this.LabelText
                    label={this.props.lan.assignedAgent}
                    text={this.props.taskAgent.name}
                    className='my-3'
                    textClass='td-task-number taskAgent-color'
                  />
                </Grid>
                <Grid>
                  <this.LabelText
                    label={this.props.lan.assignedWork}
                    text={this.props.taskAgent.workSchedule}
                    className='my-3'
                    textClass='agent-text taskAgent-color'
                  />
                </Grid>
                <Grid>
                  <this.LabelText
                    label={this.props.lan.phoneAgent}
                    text={this.formatPhone(this.props.taskAgent.phone)}
                    className='my-3'
                    textClass='agent-text taskAgent-color'
                  />
                </Grid>
                <Grid>
                  <this.LabelText
                    label={this.props.lan.emailAgent}
                    text={this.props.taskAgent.email}
                    className='my-3'
                    textClass='agent-text taskAgent-color'
                  />
                </Grid>
              </Grid>
            )}
            <Grid size={{ xs: 12, md: 5 }}>
              <Grid>
                <this.LabelText
                  label={this.props.lan.typeVehicle}
                  text={this.props.taskAgent.vehicleType}
                  className='my-3'
                  textClass='agent-text taskAgent-color'
                />
              </Grid>
              <Grid>
                <this.LabelText
                  label={this.props.lan.idVehicle}
                  text={this.props.taskAgent.vehicleId}
                  className='my-3'
                  textClass='agent-text taskAgent-color'
                />
              </Grid>
              {!RoleUtils.isUserClient(this.props.user) ? (
                <Grid>
                  <this.LabelText
                    label={this.props.lan.timeTraveled}
                    text={this.props.taskAgent.timeTaken}
                    className='my-3'
                    textClass='agent-text taskAgent-color'
                  />
                </Grid>
              ) : null}
              {!RoleUtils.isUserClient(this.props.user) ? (
                <Grid>
                  <this.LabelText
                    label={this.props.lan.distanceTraveled + ' (kms)'}
                    text={this.formatDistance(this.props.taskAgent.distanceTraveled)}
                    className='my-3'
                    textClass='agent-text taskAgent-color'
                  />
                </Grid>
              ) : null}
            </Grid>
          </Grid>
        </React.Fragment>
      </div>
    );
  }
}
const mapStateToProps = (state) => ({
	user: state.utils.session.user,
});
export default connect(mapStateToProps)(TaskAgent);
*/
